import { Col, FormGroup, FormLabel, Row } from "react-bootstrap";
import AsteriskRequired from "../../../components/Common/AsteriskRequired";
import InputText from "../../../components/Forms/Element/InputText";
import StatusCheckBox from "../../../components/Common/StatusCheckbox";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import PhoneNumberInput from "../../../components/Common/PhoneNumberInput";
import { convertStatusToBoolean } from "../../../../utils/ConverterUtils";
import CnpjInput from "../../../components/Common/CnpjInput";
import TextArea from "../../../components/Forms/Element/TextArea";
import AddressRegistration from "../../../components/Custom/Common/Address/AddressRegistration";
import { formatCNPJ } from "../../../../utils/FormatUtils";
import FormSection from "../../../components/Common/Form/FormSection";

const Form = (props) => {

    const { t } = useTranslation();
    const { status, setStatus, formik, entityData } = props;

    useEffect(() => {
        // Preenche os valores nos campos.
        if (entityData != null) {
            formik.setFieldValue('name', entityData.name);
            formik.setFieldValue('corporateName', entityData.corporateName);
            formik.setFieldValue('phone', entityData.phone);
            formik.setFieldValue('document', entityData.document ? formatCNPJ(entityData.document) : '');
            formik.setFieldValue('email', entityData.email);
            formik.setFieldValue('obs', entityData.obs);

            if (entityData.address !== null) {
                formik.setFieldValue('street', entityData.address.street);
                formik.setFieldValue('number', entityData.address.number);
                formik.setFieldValue('complement', entityData.address.complement);
                formik.setFieldValue('neighborhood', entityData.address.neighborhood);
                formik.setFieldValue('city', entityData.address.city);
                formik.setFieldValue('state', entityData.address.state);
                formik.setFieldValue('zipCode', entityData.address.zipCode);
            }

            setStatus(convertStatusToBoolean(entityData.status));
        }

        // eslint-disable-next-line
    }, [entityData]);

    return (
        <>
            <div className="form-layout form-layout--spaced">
                <FormSection
                    title={t('basic_information')}
                    description={t('vendor_basic_information_hint')}
                    icon="fa-solid fa-truck"
                >
                    <Row className="g-3">
                        <Col md={6} xl={5}>
                            <FormGroup>
                                <FormLabel>{t('name')} <AsteriskRequired /></FormLabel>
                                <InputText
                                    name="name"
                                    placeholder={t('name_placeholder')}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.name}
                                    error={formik.errors.name}
                                    maxlenght="50"
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6} xl={4}>
                            <FormGroup>
                                <FormLabel>{t('corporate_name')}</FormLabel>
                                <InputText
                                    name="corporateName"
                                    placeholder={t('corporate_name_placeholder')}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.corporateName}
                                    error={formik.errors.corporateName}
                                    maxlenght="50"
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6} xl={3}>
                            <FormGroup>
                                <FormLabel>{t('cnpj')}</FormLabel>
                                <CnpjInput
                                    name="document"
                                    placeholder={t('document')}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.document}
                                    error={formik.errors.document}
                                    maxlenght="30"
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6} xl={5}>
                            <FormGroup>
                                <FormLabel>{t('email')}</FormLabel>
                                <InputText
                                    name="email"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.email}
                                    error={formik.errors.email}
                                    placeholder={t('email_placeholder')}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6} xl={3}>
                            <FormGroup>
                                <FormLabel>{t('phone')}</FormLabel>
                                <PhoneNumberInput
                                    name="phone"
                                    formik={formik}
                                    error={formik.errors.phone}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>

                <FormSection
                    title={t('address.label')}
                    description={t('vendor_address_hint')}
                    icon="fa-solid fa-location-dot"
                >
                    <AddressRegistration formik={formik} />
                </FormSection>

                <FormSection
                    title={t('obs')}
                    description={t('vendor_notes_hint')}
                    icon="fa-solid fa-sticky-note"
                >
                    <Row>
                        <Col md={12}>
                            <FormGroup>
                                <TextArea name="obs" style={{ height: "100px" }}
                                    maxLength={255}
                                    value={formik.values.obs}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    counter="true"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>

                <FormSection
                    title={t('status')}
                    description={t('vendor_status_hint')}
                    icon="fa-solid fa-toggle-on"
                    compact
                >
                    <Row>
                        <Col md={12}>
                            <FormGroup className="mb-0">
                                <StatusCheckBox
                                    name="status"
                                    defaultChecked={status}
                                    checked={status}
                                    onClick={() => setStatus(!status)} />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>
            </div>
        </>
    );
}

export default Form;
